import { useIntl } from 'react-intl';

import { roundGuideDuration } from '@/utils/app/formatTime';

import messages from './messages';

// A session with no playable asset has no length to show, and a zero-length one is bad data
// rather than a "0 sec" session, so both render nothing at all. NaN and Infinity have to be
// rejected explicitly: both are typeof 'number' and neither satisfies `<= 0`, so they would
// otherwise reach the formatter and render as "NaN min" and "Infinity min".
export const useGuideDuration = (seconds?: number): string | undefined => {
	const { formatMessage } = useIntl();

	if (typeof seconds !== 'number' || !Number.isFinite(seconds) || seconds <= 0) {
		return undefined;
	}

	const { unit, value } = roundGuideDuration(seconds);

	return formatMessage(unit === 'minutes' ? messages.minutes : messages.seconds, { value });
};
